import React from 'react';
import DefaultButton from 'components/Utils/NewDefaultButton';
import './index.scss';
import { Device } from 'services/Native/Device';
import { useAppSelector } from 'careand-redux/store';
import { run } from 'services/FunctionUtils';
import device from 'careand-redux/slices/device';
import { getTenantIdentity } from 'hooks/useTenantIdentity';
import { PLAY_STORE_URL, APP_STORE_ITMS_URL } from 'constants/appLinks';

const STORE_NAME = {
  android: 'Play Store',
  ios: 'App Store',
} as const;

const STORE_URL = {
  android: PLAY_STORE_URL,
  ios: APP_STORE_ITMS_URL,
} as const;

export function ForceUpdateView() {
  const { name } = getTenantIdentity();
  const show = useAppSelector((state) => state.ui.oldVersion);
  const deviceType = Device.getDeviceType();

  if (!show) {
    return null;
  }

  const description = run(() => {
    if (deviceType) {
      const store = STORE_NAME[deviceType];
      return `Please go to the ${store} and download it.`;
    }
    return `You are currently using an outdated version of the ${name} web app.\nPlease refresh this page or clear your browser's cache in order to access\nour service.`;
  }, []);

  const onClickUpdate = () => {
    if (deviceType) {
      const a = document.createElement('a');
      a.href = STORE_URL[deviceType];
      a.click();
      a.remove();
    } else {
      window.location.reload();
    }
  };

  const buttonTitle = !!deviceType ? 'Update' : 'Refresh';

  return (
    <div className="force-update-view">
      <div className="content">
        <div className="title">There&apos;s a new version out!</div>
        <div className="description">{description}</div>
        <DefaultButton name={buttonTitle} className="update-button" onClick={onClickUpdate} />
      </div>
      <div className="backdrop" />
    </div>
  );
}
